import React from 'react';
import { Row, Col, Panel, Alert } from 'react-bootstrap';
import WorkItemForm from './WorkItemForm';

class WorkItem extends React.Component {
  constructor(props){
    super(props);
    props.getProducts();
    props.getWorkItem(props.params.worksheet_id,props.params.id);
    if (!props.worksheet){
      if (!props.worksheets)props.getWorkSheet(props.params.worksheet_id);
      else {
        // Try loading from the cache of worksheets first, otherwise use the API.
        var ws=props.worksheets.filter(w=>w._id===props.params.worksheet_id);
        if (ws.length>0)props.setWorkSheetState(ws[0]);
        else props.getWorkSheet(props.params.worksheet_id);
      }
    }
  }

  render(){
    if (this.props.products_loaded && this.props.worksheet && this.props.worksheet.month){
      const orderNumbers = (this.props.worksheet && this.props.worksheet.items)
        ? Array.from(new Set(
          this.props.worksheet.items
            .slice()
            .sort((a,b)=>new Date(b.date)-new Date(a.date))
            .map(i=>i.order_number)
            .filter(Boolean)
        ))
        : [];
      return (
      <div>
        <Row>
          <Col xs={12} sm={6} smOffset={3}>
            <Panel>
              <Col xs={12}>
                <WorkItemForm 
                  onSubmit={this.props.setWorkItem.bind(this,this.props.params.worksheet_id)} 
                  initialValues={this.props.initialValues}
                  products={this.props.products} 
                  working_time={this.props.working_time}
                  month={this.props.worksheet.month}
                  allowDateOverride={this.props.worksheet.allow_date_override}
                  orderNumbers={orderNumbers}
                  logout={this.props.logout}
                  goBack={this.props.goBack}
                />
                {this.props.error&&
                  <Row>
                    <Alert bsStyle='danger'>
                      {this.props.error}
                    </Alert>
                  </Row>
                }
              </Col>
            </Panel>
          </Col>
        </Row>
      </div>
    )
  } else {
    return (
      <div className="loading">
        Loading...
      </div>
    );
 
  }
  }
}

export default WorkItem;
